import { css } from 'lit';
import { css } from 'lit';

export default css`
	.dialog-form {
		border-radius: 3px;
		background: #fff;
		margin: 0 auto;
	}
	.dialog-form > * {
		padding: var(--ggutter);
	}
	.confirm-dialog-content {
		padding: calc(2 * var(--ggutter));
	}
	.dialog-body {
		padding: 0;
	}
	.dialog-form-sm {
		width: 100%;

		@media (min-width: 650px) {
			width: 50%;
		}
	}
	.dialog {
		cursor: default;
		padding: 0;
		background: transparent;
		border: none;
		white-space: normal;
		width: 100%;
		max-height: 100%;

		@media (min-width: 900px) {
			width: auto;
			min-width: 450px;
		}
		&::backdrop {
			background: rgba(0, 0, 0, 0.5);
			backdrop-filter: blur(3px);
		}
	}
	.dialog-h2,
	.dialog-header {
		margin: 0;
		font-size: inherit;
		font-weight: 600;
		padding: var(--ggutter);
	}
	.dialog-p {
		padding: 0 var(--ggutter) calc(var(--ggutter) / 2) var(--ggutter);
		text-transform: initial;
	}
	.dialog-i {
		font-style: italic;
	}
	.dialog-pt-3 {
		padding-top: var(--ggutter);
	}
	.dialog-pt-6 {
		padding-top: calc(var(--ggutter) * 1.5);
	}
	.dialog-font-size-sm {
		font-size: 1.4rem;
	}
	.dialog-close-btn {
		display: flex;
		margin-left: auto;
		cursor: pointer;
	}
	.close-icon {
		pointer-events: none;
		width: 12px;
		height: 12px;
		fill: rgb(var(--brand-grey));
	}
	.dialog-close-btn:hover > .close-icon {
		fill: rgb(var(--brand-focus));
	}
	.dialog-header {
		border-bottom: 1px solid rgb(var(--brand-grey-dimmer));
		box-shadow: var(--shadow-level-2);
	}
	::slotted([slot='contents']) {
		padding: var(--ggutter);
	}
	h2[slot='title'] {
		font-weight: bolder;
	}
	::slotted([slot='title-right']) {
		margin-left: auto;
		padding: 0 var(--ggutter);
	}
`;
